export const locale = {
    lang: 'pl',
    data: {
        'Name': 'Nazwa',
        'Category': 'Kategoria',
        'Price gross': 'Cena brutto',
        'Required time': 'Czas trwania',
        'Popularity': 'Popularność',
        'Vat rate': 'VAT',
        'New': 'Nowa',
        'Services': 'Usługi',
        'Summary': 'Podsumowanie',
        'Stats': 'Statystyki',
        'Service history': 'Historia usług',
        'Assigned workers': 'Przypisani pracownicy',
        'Assigned resources': 'Powiązane zasoby',
        'Comments': 'Komentarze',
        'Provisions': 'Prowizje',
        'Duration': 'Czas trwania',
        'minuts': 'minut',
        'Price': 'Cena',
        'times': 'razy',
        'TAX': 'VAT',
        'Reservations online': 'Rezerwacje online',
        'Service can be reserved online': 'Usługę można rezerwować online',
        'Service can not be reserved online': 'Usługi nie można rezerwować online',
        'Public description': 'Opis publiczny',
        'Private description': 'Opis prywatny',
        'No description': 'Brak opisu',
        'No images': 'Brak zdjęć',
        'Images': 'Zdjęcia',
        'Require': 'Wymagaj',
        'Require additionally': 'Wymagaj także',
        'or': 'lub',
        'Documents': 'Dokumenty',
        'Save': 'Zapisz',
        'Service data': 'Dane usługi',
        'Add category': 'Dodaj kategorię',
        'Description': 'Opis',
        'Resources': 'Zasoby',
        'Remove': 'Usuń',
        'Add resource': 'Dodaj zasób',
        'Add resources group': 'Dodaj grupę zasobów',
        'Connected devices': 'Połączone urządzenia',
        'Edit': 'Edycja',
        'Delete': 'Usuń',
        'Actions': 'Akcje',
        'All services': 'Wszystkie usługi',
        'Saving': 'Zapisywanie',
        'Basic data': 'Dane podstawowe',
        'Required credits': 'Wymagane kredyty',
        'Type to filter services list...': 'Wpisz tutaj aby wyszukać usługę...',
        'Group training': 'Trening grupowy'
    }
};
